































































































































































































































































































































































































































import Vue from 'vue';
import {
  // genDownloadOriginalImageUrl,
  // genDownloadImageUrlsByImage
  sizes,
  genDownloadImageUrl,
} from '@/modules/image';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import {
  exhibition as exhibitionM,
  Exhibition,
  calender,
  // Option,
  OptionValue,
  options,
} from 'mostra';

const publishTypes = [
  { value: 1, text: '公開' },
  { value: 2, text: 'ティーザー公開' },
  { value: 99, text: '非公開' },
];

type Images = {
  logo: string | null;
  header: string | null;
  kvs: string[];
  tops: string[];
}

const optionValueData: OptionValue = {
  value: null,
  text: '',
  color: '',
  style: {
    text: '',
    style: null,
    textLanguage: 'JP',
  },
};

export type DataType = {
  exhibition: Exhibition | null;
  loading: boolean;
  titleFont: OptionValue;
  bodyFont: OptionValue;
  footerFont: OptionValue;
  images: Images;
  teaserImages: string[];
  spImage: string | null;
  spImages: string[];
  offlineMapImages: string[][];
  boothV2Images: string[][]
  option: {
    errorCorrectionLevel: string;
    maskPattern: number;
    margin: number;
    scale: number;
    width: number;
    color: {
      dark: string;
      light: string;
    }
  },
  ssrUrl: string;
};

export default Vue.extend({
  name: 'admin-admin-exhibition-detail',
  components: {
    VueQrcode,
  },
  data(): DataType {
    return {
      ssrUrl: process.env.VUE_APP_SSR_URL,
      exhibition: null,
      loading: false,
      titleFont: optionValueData,
      bodyFont: optionValueData,
      footerFont: optionValueData,
      images: {
        logo: '',
        header: '',
        kvs: [],
        tops: [],
      },
      teaserImages: [],
      spImage: '',
      spImages: [],
      offlineMapImages: [],
      boothV2Images: [],
      option: {
        errorCorrectionLevel: 'M',
        maskPattern: 0,
        margin: 0,
        scale: 2,
        width: 300,
        color: {
          dark: '#000000FF',
          light: '#FFFFFFFF',
        },
      },
    };
  },
  async mounted() {
    this.$loading(true);
    this.loading = true;
    try {
      await this.fetchData();
      await this.fetchImages();
      console.log('exhibition', this.exhibition);
    } catch (error: any) {
      this.$error('取得に失敗しました。', error);
    } finally {
      this.$loading(false);
      this.loading = false;
    }
  },
  methods: {
    formatDate(dt: any) {
      return calender.formatDate(dt);
    },
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    formatStringArray(array: string[]) {
      return array.join(' , ');
    },
    getPublishTypeText(publishType: number): string {
      const option = publishTypes.find((o) => o.value === publishType);
      return option ? option.text : '';
    },
    async fetchData() {
      try {
        const id = this.$route.params.id;
        this.exhibition = await exhibitionM.load(id);
        if (!this.exhibition || !this.exhibition.data || !this.exhibition.data.design) throw new Error('exhibition is null');
        const e = this.exhibition.data;
        if (e.design.title && e.design.title.font) {
          this.titleFont = options.get(options.titleFontOptions, e.design.title.font);
        }
        if (e.design.body && e.design.body.font) {
          this.bodyFont = options.get(options.bodyFontOptions, e.design.body.font);
        }
        if (e.design.footer && e.design.footer.font) {
          this.footerFont = options.get(options.bodyFontOptions, e.design.footer.font);
        }
      } catch (error: any) {
        this.$fatal(error);
      }
    },
    async fetchImages() {
      try {
        if (!this.exhibition || !this.exhibition.data) return;
        const e = this.exhibition.data;
        if (!e.images || !e.teaser || !e.sp) throw new Error('exhibition data is null');
        if (e.images.logo && e.images.logo.id) {
          this.images.logo = await this.downloadImageUrl(e.images.logo.id);
        }
        if (e.images.header && e.images.header.id) {
          this.images.logo = await this.downloadImageUrl(e.images.header.id);
        }
        for (const kv of e.images.kvs) {
          if (kv.id) {
            const url = await this.downloadImageUrl(kv.id);
            if (url) {
              this.images.kvs.push(url);
            }
          }
        }
        for (const top of e.images.tops) {
          if (top.id) {
            const url = await this.downloadImageUrl(top.id);
            if (url) {
              this.images.tops.push(url);
            }
          }
        }
        for (const tImage of e.teaser.images) {
          if (tImage.id) {
            const url = await this.downloadImageUrl(tImage.id);
            if (url) {
              this.teaserImages.push(url);
            }
          }
        }
        if (e.sp.image && e.sp.image.id) {
          this.spImage = await this.downloadImageUrl(e.sp.image.id);
        }
        for (const sImage of e.sp.images) {
          if (sImage.id) {
            const url = await this.downloadImageUrl(sImage.id);
            if (url) {
              this.spImages.push(url);
            }
          }
        }
        for (const [i, offline] of e.offlines.entries()) {
          this.offlineMapImages.push([]);
          for (const map of offline.maps) {
            if (map.image && map.image.id) {
              const url = await this.downloadImageUrl(map.image.id);
              if (url) {
                this.offlineMapImages[i].push(url);
              }
            }
          }
        }
        for (const [i, boothV2] of e.boothsV2.entries()) {
          this.boothV2Images.push([]);
          for (const kv of boothV2.images.kvs) {
            if (kv.id) {
              const url = await this.downloadImageUrl(kv.id);
              if (url) {
                this.boothV2Images[i].push(url);
              }
            }
          }
        }
        console.log(this.images);
      } catch (error: any) {
        this.$fatal(error);
      }
    },
    async downloadImageUrl(imageId: string): Promise<string | null> {
      const downloadedUrl = await genDownloadImageUrl(
        sizes.x512,
        imageId,
      );
      return downloadedUrl;
    },
    async onClickUpdateExhibition() {
      this.$loading(true);
      try {
        if (!this.exhibition) throw new Error('exhibition is null');
        const uid = this.$auth.uid;
        this.exhibition = await exhibitionM.save(uid, this.exhibition, process.env.VUE_APP_SSR_URL);
      } catch (error: any) {
        this.$error('保存に失敗しました', error);
      } finally {
        this.$success('保存しました');
        this.$loading(false);
      }
    },
  },
});
